import {useEffect, useState} from 'react';
import uuidv4 from 'uuid/v4';
import {useWebSocket} from '../../context/WebSocketProvider';

export default function useCheckLockPatient(patientId) {
    const [isPatientLockout, setIsPatientLockout] = useState(false);

    const uniqueId = '' + uuidv4();
    const {manageSubscription, sendMessage, message} = useWebSocket();

    useEffect(() => {
        if (patientId) {
            manageSubscription(`patients_lock_${patientId}`);
            const data = {
                lock_action: 'is_locked',
                lock_id: `patients_lock_${patientId}`,
            };
            sendMessage(data, 'lock_svc', uniqueId);

            return () => {
                manageSubscription(`patients_lock_${patientId}`, false);
            };
        }
    }, [patientId]);

    useEffect(() => {
        if (message) {
            const {lock_status} = message.data;
            if (lock_status) {
                setIsPatientLockout(lock_status !== 'unlocked');
            } else {
                setIsPatientLockout(false);
            }
        }
    }, [message]);

    return [isPatientLockout];
}